import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { IfcModel } from '../models/ifc-model.model';
import { IfcModelInterface } from '../interfaces/ifc-model.interface';

@Injectable({
  providedIn: 'root',
})
export class ModelsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get model by ID.
   *
   * @param projectId ProjectId.
   * @param modelId model Id.
   * @returns Model.
   */
  public getModelById(projectId: number, modelId: number): Observable<IfcModel> {
    this.path = `/v1/bimdata/projects/${projectId}/model/${modelId}`;
    return this.getModel<IfcModel>();
  }

  /**
   * Create IfcModel instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `IfcModel` instance.
   */
  public createNewInstance(jsonObject: IfcModelInterface): IfcModel {
    return new IfcModel(jsonObject);
  }
}
